import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { useState } from 'react';
import styled from '@xstyled/styled-components';
import { Layout } from 'antd';
import { createGlobalStyle } from 'styled-components';
import { AppHeader } from './app-header.component';
import { styleVariables } from '../../style';
import { TransparentButtonCSS } from '../button';
import { AppSidebarComponent } from './app-sidebar';
import { Responsive } from '../responsive';
import { AppPopupSidebarComponent } from './app-sidebar/app-popup-sidebar.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Content = Layout.Content;
export var LogoPosition;

(function (LogoPosition) {
  LogoPosition["center"] = "center";
  LogoPosition["left"] = "left";
})(LogoPosition || (LogoPosition = {}));

var GlobalStyle = createGlobalStyle(["body{overflow:hidden;}.success-creating-modal{width:32% !important;border-radius:16px;.ant-modal-confirm-btns button{", ";}}.ant-picker-panel-container{.ant-picker-content{.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner{background:", ";}}}*{scrollbar-width:thin;}*::-webkit-scrollbar{width:8px;}::-webkit-scrollbar:hover{width:12px;}*::-webkit-scrollbar-track{background:transparent;}*::-webkit-scrollbar-thumb{background-color:", ";border-radius:20px;border:none;}"], TransparentButtonCSS, styleVariables.colors.blue4, styleVariables.colors.gray8);
var StyledLayout = styled(Layout)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: transparent;\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n"])));
var LayoutContainer = styled(Layout)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /* background: ", "; */\n  width: 100%;\n  height: calc(100vh - 64px);\n  /* position: absolute; */\n  /* top: 56px; */\n  overflow: hidden;\n"])), styleVariables.colors.gray1);
var StyledResponsiveDesktopScreen = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  height: -webkit-fill-available;\n"])));
export var AppLayout = function AppLayout(props) {
  var menuItems = props.menuItems,
      urlNavigateAccountSettingPage = props.urlNavigateAccountSettingPage,
      translation = props.translation,
      selectedKeys = props.selectedKeys,
      logoSrc = props.logoSrc,
      children = props.children,
      bottomMenuItems = props.bottomMenuItems,
      isLoadingUserInfo = props.isLoadingUserInfo,
      userInfo = props.userInfo,
      isSidebarCollapsed = props.isSidebarCollapsed,
      withoutSidebar = props.withoutSidebar,
      navigateToPath = props.navigateToPath,
      collapseSidebar = props.collapseSidebar,
      hamburgerHeaderSrc = props.hamburgerHeaderSrc,
      primaryHeader = props.primaryHeader,
      withoutHeader = props.withoutHeader;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var showDrawer = function showDrawer() {
    setOpen(true);
  };

  var onClose = function onClose() {
    setOpen(false);
  };

  return /*#__PURE__*/_jsxs(StyledLayout, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), !withoutHeader && /*#__PURE__*/_jsx(AppHeader, {
      logoSrc: logoSrc,
      hamburgerHeaderSrc: hamburgerHeaderSrc,
      showDrawer: showDrawer,
      primaryHeader: primaryHeader,
      withoutSidebar: withoutSidebar
    }), /*#__PURE__*/_jsxs(LayoutContainer, {
      children: [/*#__PURE__*/_jsx(Responsive.MobileScreen, {
        children: /*#__PURE__*/_jsx(AppPopupSidebarComponent, {
          logoSrc: logoSrc,
          selectedKeys: selectedKeys,
          menuItems: menuItems,
          translation: translation,
          isLoadingUserInfo: isLoadingUserInfo,
          urlNavigateAccountSettingPage: urlNavigateAccountSettingPage,
          bottomMenuItems: bottomMenuItems,
          userInfo: userInfo,
          navigateToPath: navigateToPath,
          hamburgerHeaderSrc: hamburgerHeaderSrc,
          open: open,
          onClose: onClose
        })
      }), /*#__PURE__*/_jsx(Responsive.DesktopScreen, {
        children: !withoutSidebar && /*#__PURE__*/_jsx(StyledResponsiveDesktopScreen, {
          children: /*#__PURE__*/_jsx(AppSidebarComponent, {
            selectedKeys: selectedKeys,
            menuItems: menuItems,
            translation: translation,
            isLoadingUserInfo: isLoadingUserInfo,
            urlNavigateAccountSettingPage: urlNavigateAccountSettingPage,
            bottomMenuItems: bottomMenuItems,
            userInfo: userInfo,
            isSidebarCollapsed: isSidebarCollapsed,
            navigateToPath: navigateToPath,
            collapseSidebar: collapseSidebar
          })
        })
      }), /*#__PURE__*/_jsx(Content, {
        children: children
      })]
    })]
  });
};